import * as React from 'react'
import Variation from './Variation'
import { get } from 'lodash'

export default class VariantionContainer extends React.Component<any, any> {
    CreateVariation: any
    constructor(props: any) {
        super(props)
        this.state = {
            hiscox: [],
            hcc: [],
        }
    }

    componentWillMount() {
        if (this.props.editRenewal) {
            this.props.getRenewalVariation(this.props.quoteId)
        } else {
            this.props.getQuoteVariation(this.props.quoteId)
        }
    }

    componentWillUnmount() {
        this.props.step05.response = null
    }

    createNewVariation = (reqQuote) => {
        this.props.createQuoteVariation(this.props.quoteId, reqQuote)
    }

    renderVariations = (type: any) => {
        const { step05, renewalStep05, editRenewal } = this.props
        const item = editRenewal ? renewalStep05.response.filter(data => data.quoteType === type) :
            step05.response.filter(data => data.quoteType === type)
        const step05CP = editRenewal ? renewalStep05 : step05

        if (step05CP.response && step05CP.done) {
            return (item.length > 0 && item[0] && item[0].premium !== 0) &&
                (
                    <Variation
                        quoteTitle={type.toUpperCase()}
                        type={type}
                        optionsList={type === 'hcc' ? false : true}
                        excessShow={type === 'hiscox' ? false : true}
                        key={0}
                        index={0}
                        values={item[0]}
                        quoteId={this.props.quoteId}
                        delQuoteVariation={this.props.delQuoteVariation}
                        issueQuoteVariation={this.props.issueQuoteVariation}
                        updateQuoteVariation={
                            this.props.editRenewal
                                ? this.props.updateRenewalVariation
                                : this.props.updateQuoteVariation
                        }
                        bindQuoteVariation={this.props.bindQuoteVariation}
                        inviteQuoteVariation={this.props.inviteQuoteVariation}
                        checkSoftReferral={this.props.checkSoftReferral}
                        renewalBindQuoteVariation={this.props.renewalBindQuoteVariation}
                        renewalReferralReasons={this.props.renewalReferralReasons}
                        loading={get(step05CP, 'loading', false)}
                        history={this.props.history}
                        softReferrals={get(step05CP, 'softReferrals')}
                        dirtySteps={this.props.dirtySteps}
                        editRenewal={this.props.editRenewal}
                        editQuotes={this.props.editQuotes}
                        totalCollection={this.props.totalCollection}
                        checkUpdate={this.props.checkUpdate}
                        quoteData={this.props.quoteData}
                        checkRenewalStep02OnlyUpdate={this.props.checkRenewalStep02OnlyUpdate}
                        checkStep04update={this.props.checkStep04update}
                        createQuote={this.props.createQuote}
                        exhibitItem={this.props.exhibitItem}
                        commissionList={get(step05CP, 'commissionList', [])}
                        maxCommission={get(step05CP, type === 'hcc' ? 'maxHccCommission' : 'maxHiscoxCommission', 3.5)}
                        minCommission={get(step05CP, 'minCommission', 0)}
                        maxExcession={get(step05CP, 'maxExcession', 5000)}
                        minExcession={get(step05CP, 'minExcession', 500)}
                    />)
        } else {
            return <div>{type} - loading</div>
        }
    }

    render() {
        let step05
        if (this.props.editRenewal) {
            step05 = this.props.renewalStep05
        } else {
            step05 = this.props.step05
        }

        this.props.variationsStep05(step05.response)

        return (
            <div className="quote__form__group form__w100 variantion__container">

                <div className="hcc-section">
                    {this.renderVariations('hcc')}
                </div>
                <div className="hiscox-section">
                    {this.renderVariations('hiscox')}
                </div>
            </div>
        )

    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05cp/components/VariantionContainer.tsx